import { useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import XrCardAv from '../../components/XrCardAv.tsx';
import XrTextAv from '../../components/XrTextAv.tsx';
import XrInputAv from '../../components/XrInputAv.tsx';
import XrButtonAv from '../../components/XrButtonAv.tsx';
import { apiPost, parseBouncer, API_URL_AUTH } from '../../helpers/api.ts';
import { updateToken, updateUser } from "../../reducers/authorization/actions";

const LoginPage = () => {
  const dispatch = useDispatch();
  
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]); 
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const onTextChange = (field, e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const actionLogin = async () => {
    const { email, password }  = formData;
    setIsLoading(true);
    try {
      const request = await apiPost(
        API_URL_AUTH.BY_CREDENTIALS,
        '',
        { email, password }
      );
      const response = await request.json(request);
      const bouncer = parseBouncer();
      bouncer.token = response.data.token;
      localStorage.setItem('bouncer', JSON.stringify(bouncer));
      dispatch(updateUser(response.data.user));
      dispatch(updateToken(response.data.token));
    } catch (error) {
      dispatch(updateUser(null));
      dispatch(updateToken(''));
      setErrors([
        'Kata sandi salah atau e-mail tidak terdaftar'
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoginPageWrapper>
      <div className='login__background' />
      <div className='login__form'>
        <XrCardAv>
          <div className="card--title">
            <div className="card--title requestBooking__toolbar">
              <div>
                <XrTextAv tag='h2' variant='title'>
                  Sistem Peminjaman Ruangan
                </XrTextAv>
                <XrTextAv tag='p' variant='description'>
                  Masuk ke dalam sistem agar dapat menggunakan fasilitas peminjaman ruangan dan inventaris.
                </XrTextAv>
              </div>
            </div>
          </div>
          <div className="card--body">
            <XrInputAv
              type='email'
              required={true}
              errorMessage={errors}
              label='Alamat Email'
              disabled={isLoading}
              isLoading={isLoading}
              value={formData.email}
              onChange={e => onTextChange('email', e)}
            />
            <XrInputAv
              type='password'
              label='Kata Sandi'
              required={true}
              value={formData.password}
              disabled={isLoading}
              isLoading={isLoading}
              onChange={e => onTextChange('password', e)}
              errorMessage={[]}
            />
            <XrButtonAv
              size='large'
              caption='Masuk'
              color='primary'
              disabled={isLoading}
              onClick={actionLogin}
            />
            <XrButtonAv
              size='large'
              disabled={isLoading}
              onClick={actionLogin}
              caption='Tidak Dapat Masuk'
              style={{ marginTop: '5px' }}
            />
          </div>
        </XrCardAv>
      </div>
    </LoginPageWrapper>
  );
};

const LoginPageWrapper = styled.div`  
  z-index: 99;
  position: fixed;
  min-width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  & .login__form {
    width: 400px;
    position: relative;
    z-index: 2;
  }

  & .login__background {
    z-index: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0,0,0,0.7);
  }
`;

export default LoginPage;